import Link from "next/link";
import { inter } from "../fonts/inter.ts";
import "../animations/animate.css";
import AnimatedBody from "../animations/AnimatedBody.tsx";
import AnimatedTitle from "../animations/AnimatedTitle.tsx";
import AnimatedWords from "../animations/AnimatedWords.tsx";
import { motion } from "framer-motion";
import ContactBackground from "../components/background/ContactBackground.tsx";
import React from "react";

const Contact = () => {
    return (
        <motion.section
            className="relative z-10 flex min-h-[70vh] w-full items-center justify-center overflow-hidden py-12 sm:py-16 md:min-h-[75vh] md:py-20 lg:min-h-[85vh] lg:py-24"
            id="contact"
            initial="initial"
            animate="animate"
        >
            <ContactBackground />
            <div className="relative z-10 mx-auto flex w-[90%] flex-col items-center justify-center">
                <div
                    className={`flex flex-col items-center justify-center ${inter.className} relative w-full lg:max-w-[1440px]`}
                >
                    <AnimatedWords
                        title={"contact"}
                        style={
                            "flex flex-col items-center text-center text-[60px] font-extrabold uppercase leading-[1.3em] text-[#e4ded7] sm:text-[90px] sm:leading-[0.9em] md:text-[120px] lg:text-[150px] xl:text-[200px]"
                        }
                    />
                </div>

                <div className="mt-10 flex w-full flex-col items-center justify-center gap-8 sm:mt-14 md:mt-16 lg:mt-12 lg:max-w-[1440px]">
                    <AnimatedBody
                        text={"Une question ou une proposition ?"}
                        className="text-center text-[16px] font-semibold text-[#e4ded7] sm:text-[18px] md:text-[20px]"
                    />

                    <div className="flex flex-col items-center gap-6 text-center md:flex-row md:gap-10 lg:gap-16">
                        <Link
                            href="mailto:contact@neil-broneer.fr"
                            target="_blank"
                            className="text-[18px] font-bold text-[#e4ded7] underline underline-offset-4 transition-opacity hover:opacity-70 sm:text-[20px] md:text-[22px] lg:text-[26px]"
                        >
                            contact@neil-broneer.fr
                        </Link>

                        <Link
                            href="https://www.linkedin.com/in/neil-broneer/"
                            target="_blank"
                            className="text-[18px] font-bold text-[#e4ded7] underline underline-offset-4 transition-opacity hover:opacity-70 sm:text-[20px] md:text-[22px] lg:text-[26px]"
                        >
                            LinkedIn
                        </Link>

                        <Link
                            href="tel:+33766840233"
                            className="text-[18px] font-bold text-[#e4ded7] underline underline-offset-4 transition-opacity hover:opacity-70 sm:text-[20px] md:text-[22px] lg:text-[26px]"
                        >
                            07 66 84 02 33
                        </Link>
                    </div>
                </div>
            </div>
        </motion.section>
    );
};

export default Contact;
